export default __webpack_public_path__ + "static/media/prize_count.a1324b74.png";